import {Button, Card, CardContent, CardHeader, Grid, Table, TableCell, TableRow, Typography} from "@mui/material";
import Loading from "../../components/Common/Loading";
import SimpleTable from "../../components/Common/Elements";
import {useGetChatCMQuery} from "../../core/api/clockmaker-clans-api";
import {format} from "date-fns";


const ClanStatus = (props) => {

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetChatCMQuery(props.userId)



    return (
        <Loading
            isLoading={isLoading}
            isError={isError}
            error={error}
            isSuccess={isSuccess}
        >
            {data!=undefined && data.hasOwnProperty('response') &&
                <Grid container spacing={2}>

                    <Grid size={12}>
                        <Card>
                            <CardContent>

                                <Typography sx={{fontSize: 16}}>
                                    Status
                                </Typography>

                            </CardContent>
                            <Table>
                                <TableRow>
                                    <TableCell>userID</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>updatedAt</TableCell>
                                </TableRow>
                                {data.response.history.filter(item => item.type=='MEMBER_STATUS').map(item => (
                                    <TableRow>
                                        <TableCell>{item.userId}</TableCell>

                                        <TableCell>
                                            {item.customData.status}
                                        </TableCell>
                                        <TableCell>
                                            {format(item.updatedAt, "dd.MM.yyyy HH:mm:ss")}
                                        </TableCell>
                                    </TableRow>
                                ))
                                }
                            </Table>
                        </Card>
                    </Grid>
                </Grid>
            }
        </Loading>
    )
}

export default ClanStatus
